<div layout-fill layout="column" layout-align="center none">
    <div layout="row" layout-align="center none">
        <mat-card class="loggedOutCard" fxFlex.gt-xs="60%" fxFlex.gt-md="35%" fxFlex.xl="25%">
            <mat-card-header class="justifyContentCenter">
                <mat-card-title class="forgotPasswordTitle">Reset Password</mat-card-title>
            </mat-card-header>
            <form [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit(submitBtn)">
                <mat-card-content>
                    <div>
                        <mat-form-field class="full-width" appearance="outline">
                            <mat-label>Password</mat-label>
                            <input matInput placeholder="Password" type="password" formControlName="password" required [type]="hide ? 'password' : 'text'">
                            <mat-icon matSuffix (click)="hide = !hide" class="showPasswordIcon">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                            <mat-error *ngIf="resetPasswordForm.controls.password.errors?.pattern">Should be at least 8 characters long and contain one number, one character and one special character</mat-error>
                        </mat-form-field>
                    </div>
                    <div>
                        <mat-form-field class="full-width" appearance="outline">
                            <mat-label>Confirm Password</mat-label>
                            <input matInput placeholder="Password" type="password" formControlName="confirmPassword" required [type]="hideConfirm ? 'password' : 'text'">
                            <mat-icon matSuffix (click)="hideConfirm = !hideConfirm" class="showPasswordIcon">{{hideConfirm ? 'visibility_off' : 'visibility'}}</mat-icon>
                            <mat-error *ngIf="resetPasswordForm.controls.confirmPassword.errors?.match">Passwords must match</mat-error>
                        </mat-form-field>
                    </div>
                </mat-card-content>
                <mat-card-actions>
                    <button mat-raised-button color="primary" class="loginBtn" type="submit" #submitBtn>Reset Password</button>
                    <a mat-button routerLink="/login" class="padding0 fontWeight400">Back to Login</a>
                </mat-card-actions>
            </form>
        </mat-card>
    </div>
</div>
